<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">账号：</div>
        <el-select class="filter__input" size="mini" v-model="filters.mode" filterable placeholder="请选择">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in modeList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">收支类型：</div>
        <el-select class="filter__input" size="mini" v-model="filters.bill_type" filterable placeholder="请选择">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in billTypeList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">金额：</div>
        <el-input v-model="filters.amount" placeholder="" size="mini" class="filter__input"></el-input>
      </div>

      <div class="filter__item">
        <div class="filter__name">是否退款：</div>
        <el-select class="filter__input" size="mini" v-model="filters.refund" filterable placeholder="请选择">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in refundList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn ml-auto" @click="uploadDialog = !uploadDialog">导入</button>
      <div class="flex jcb mt-20">
        <div class="filter__item">
          <div class="filter__name">项目：</div>
          <adSelect v-model="filters.adid" :lists.sync="adLists"/>
        </div>
        <div class="filter__item">
          <div class="filter__name">口令墙：</div>
          <watchSelect v-model="filters.awid" :lists.sync="watchwordLists"/>
        </div>
        <div class="filter__item">
          <div class="filter__name">任务墙：</div>
          <taskSelect v-model="filters.etid" :lists.sync="taskLists"/>
        </div>
        <div class="filter__item">
          <div class="filter__name">时间：</div>
          <el-date-picker
              v-model="filters.dateTime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions" size='small'>
            </el-date-picker>
        </div>
        <div class="filter__item">
          <div class="filter__name">备注：</div>
          <el-input v-model="filters.remark" placeholder="" size="mini" class="filter__input"></el-input>
        </div>
       </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" show-summary mt-20>
      <el-table-column prop="trade_time" label="交易时间" width="" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.trade_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="lrid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="mode" label="账号" width="100" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.mode == 3">小小贝</div>
          <div v-if="scope.row.mode == 2">诗雄支付宝</div>
          <div v-if="scope.row.mode == 1">云山支付宝</div>
        </template>
      </el-table-column>
      <el-table-column prop="adid" label="项目" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.adid">
            <span>{{scope.row.title}}({{scope.row.adid}})</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="awid" label="口令" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.awid">{{scope.row.aw_title}}({{scope.row.awid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="etid" label="任务" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.etid">{{scope.row.et_title}}({{scope.row.etid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="bind" label="是否绑定" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.bind == 1">是</div>
          <div v-if="scope.row.bind == 0">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="methods" label="交易类型" width="" align="center">
      </el-table-column>
      <el-table-column prop="channel" label="交易渠道" width="" align="center">
      </el-table-column>
      <el-table-column prop="account" label="账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="username" label="昵称" width="" align="center">
      </el-table-column>
      <el-table-column prop="bill_type" label="收支类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.bill_type == 1">收入</div>
          <div v-if="scope.row.bill_type == 0">支出</div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额" width="" align="center">
      </el-table-column>
      <!--
      <el-table-column prop="balance" label="余额" width="" align="center">
      </el-table-column>
      -->
      <el-table-column prop="status" label="状态" width="" align="center">
      </el-table-column>
      <el-table-column prop="refund" label="是否退款" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.refund == 1">已退款</div>
          <div v-if="scope.row.refund == 0">未退款</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="备注" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <span class="underline fc-blue pointer">{{scope.row.remark}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn ml-10" @click="editInfo(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="上传收支记录" :visible.sync="uploadDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">账号：</div>
            <el-select class="dataForm__input" size="mini" v-model="mode" filterable placeholder="请选择">
              <el-option :label="item.name" :value="item.value" v-for="(item, index) in modeList" :key="index"></el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">导入数据：</div>
            <el-upload
              ref="ledgerUpload"
              class="upload-demo"
              drag
              action=""
              :limit="1"
              accept=".xls,.xlsx"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :http-request="ledgerRecordUpload"
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="收支记录编辑" :visible.sync="infoDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID:</div>
            <div class="">{{ledgerRecordInfo.lrid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">交易时间:</div>
            <div v-html="formatTimeStamp(ledgerRecordInfo.trade_time)"></div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">账号:</div>
            <div>{{ledgerRecordInfo.account}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">收入/支出:</div>
            <div v-if="ledgerRecordInfo.bill_type == 1">收入</div>
            <div v-if="ledgerRecordInfo.bill_type == 0">支出</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">金额:</div>
            <div>{{ledgerRecordInfo.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">是否绑定</div>
            <el-radio-group v-model="ledgerRecordInfo.bind">
              <div class="dib mr-20">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
              <div class="dataForm__name">项目</div>
              <el-select placeholder="请选择" v-model="ledgerRecordInfo.adid" filterable @change="handleAdidChange">
                <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
              </el-select>
          </div>
          <div class="dataForm__item mt-20">
              <div class="dataForm__name">口令</div>
              <el-select placeholder="请选择" v-model="ledgerRecordInfo.awid" filterable @change="handleAwidChange">
                <el-option :label="item.title" :value="item.awid" v-for="(item, index) in watchwordLists" :key="index"></el-option>
              </el-select>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">备注</div>
            <el-input  type="textarea" v-model="ledgerRecordInfo.remark" placeholder="" rows="4" size="small" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">是否退款</div>
            <el-radio-group v-model="ledgerRecordInfo.refund">
              <div class="dib mr-20">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">收支列表ID:</div>
            <el-input v-model="ledgerRecordInfo.lid" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="ledgerRecordEdit">保存</div>
          <div class="gray-large-btn" @click="infoDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import {ledgerRecordLists, ledgerRecordEdit, ledgerRecordUpload} from '../../../api/api'
import util from '../../../script/util'
import uploadHeadImage from '../../../components/uploadImage.vue'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
import watchSelect from '../../../components/data-select/watchSelect.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
export default {
  name: 'ledgerRecordList',
  components: {
    uploadHeadImage,
    adSelect,
    operSelect,
    watchSelect,
    taskSelect
  },
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        mode: '',
        adid: '',
        awid: '',
        etid: '',
        bill_type: '',
        amount: '',
        refund: '',
        remark: '',
        dateTime: '',
        start_time: '',
        end_time: ''
      },
      adLists: [],
      operLists: [],
      watchwordLists: [],
      taskLists: [],
      lists: [],
      listLoading: false,
      uploadDialog: false,
      infoDialog: false,
      mode: '',
      ledgerRecordInfo: {
        lrid: '',
        trade_time: '',
        adid: '',
        awid: '',
        bind: '',
        title: '',
        channel: '',
        orderid: '',
        bill_type: '',
        account: '',
        amount: '',
        status: 0,
        remark: '',
        refund: 0,
        lid: 0
      },
      modeList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '云山支付宝',
          value: 1
        },
        {
          name: '诗雄支付宝',
          value: 2
        },
        {
          name: '小小贝',
          value: 3
        }
      ],
      billTypeList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '支出',
          value: 0
        },
        {
          name: '收入',
          value: 1
        }
      ],
      refundList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '未退款',
          value: 0
        },
        {
          name: '已退款',
          value: 1
        }
      ],
      pickerOptions: {
        shortcuts: []
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    uploadSuccess (res) {
      // 去掉文件列表
      this.$refs['ledgerUpload'].clearFiles()
      // this.$refs.upload.clearFiles()
    },
    uploadError (res) {
      // 去掉文件列表
      this.$refs['ledgerUpload'].clearFiles()
      // this.$refs.upload.clearFiles()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['amount', 'cost', 'income'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    dateTimeChange () {
      this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
      this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
    },
    handleAdidChange () {
      this.ledgerRecordInfo.awid = ''
    },
    handleAwidChange () {
      this.watchwordLists.forEach((item) => {
        if (item.awid === this.ledgerRecordInfo.awid) {
          this.ledgerRecordInfo.adid = item.adid
        }
      })
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.getList()
    },
    editInfo (index) {
      this.infoDialog = true
      for (let key in this.ledgerRecordInfo) {
        this.ledgerRecordInfo[key] = this.lists[index][key]
      }
      if (this.ledgerRecordInfo.adid === 0) {
        this.ledgerRecordInfo.adid = ''
      }
      if (this.ledgerRecordInfo.awid === 0) {
        this.ledgerRecordInfo.awid = ''
      }
    },
    ledgerRecordEdit (lrid) {
      let params = {
        lrid: this.ledgerRecordInfo.lrid,
        bind: this.ledgerRecordInfo.bind,
        adid: this.ledgerRecordInfo.adid,
        remark: this.ledgerRecordInfo.remark,
        refund: this.ledgerRecordInfo.refund,
        lid: this.ledgerRecordInfo.lid
      }

      if (this.ledgerRecordInfo.awid !== '') {
        params['awid'] = this.ledgerRecordInfo.awid
      }

      let content = ''

      if (params.refund === 1 && params.lid === 0) {
        content = '退款必须关联收支列表ID'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      ledgerRecordEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.getList()
          this.infoDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    ledgerRecordUpload (params) {
      if (this.mode === '') {
        this.$notify({
          title: '失败',
          message: '请选择账号',
          type: 'error'
        })
        return
      }

      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      form.append('mode', this.mode)

      ledgerRecordUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.mode = ''
          this.uploadDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.mode !== '') {
        params.mode = filters.mode
      }
      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.etid !== '') {
        params.etid = filters.etid
      }
      if (filters.bill_type !== '') {
        params.bill_type = filters.bill_type
      }
      if (filters.amount !== '') {
        params.amount = filters.amount
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      if (filters.refund !== '') {
        params.refund = filters.refund
      }
      if (filters.remark !== '') {
        params.remark = filters.remark
      }

      this.listLoading = true
      ledgerRecordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.mode': 'getList',
    'filters.adid': 'getList',
    'filters.awid': 'getList',
    'filters.etid': 'getList',
    'filters.bill_type': 'getList',
    'filters.amount': 'getList',
    'filters.dateTime': 'dateTimeChange',
    'filters.start_time': 'getList',
    'filters.refund': 'getList',
    'filters.remark': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/finance/ledgerRecordList.vue